import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '../../UserProvider';

export default function LogoutPage() {
  const navigate = useNavigate();
  const { setCurrentUser } = useCurrentUser();

  useEffect(() => {
    localStorage.removeItem('refresh_token');
    setCurrentUser(null);
    navigate('/login', { replace: true });
  }, [navigate, setCurrentUser]);

  return null; // or a spinner if you want
}